import React from 'react';
import QueueAnim from 'rc-queue-anim';
/* replace-start-value = import { getChildrenToRender } from './utils'; */
import { getChildrenToRender } from '../../utils';
/* replace-end-value */
/* replace-start */
import './index.less';
/* replace-end */
class Footer4 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;
    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        {/* <div {...dataSource.left} data-edit="image">
          <img src={dataSource.left.children} width="100%" alt="img" />
        </div> */}
        <div
          {...dataSource.left}
          data-edit="image"
        >
          <img src={dataSource.left.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.right}>
          <div className="inner">
            <QueueAnim
              {...dataSource.rightTop}
              key="right1"
              type="bottom"
              duration={1000}
              leaveReverse
              ease={['easeOutQuad', 'easeInOutQuad']}
            >
              {dataSource.rightTop.children.map(getChildrenToRender)}
            </QueueAnim>
            <QueueAnim
              {...dataSource.rightBottom}
              key="right2"
              type="right"
              duration={1000}
              leaveReverse
              ease={['easeOutQuad', 'easeInOutQuad']}
            >
              {dataSource.rightBottom.children.map(getChildrenToRender)}
            </QueueAnim>
          </div>
        </div>
      </div>
    );
  }
}
export default Footer4;
